import { ReactNode, Ref } from "react";

import { IgButton } from "@intelligems/ig-theme";

import { DESIGN_TOKENS } from "../constants";

type ToolbarButtonProps = {
  children: ReactNode;
  onClick: () => void;
  title: string;
  // Declarative active highlight (e.g. the panel toggle buttons).
  active?: boolean;
  // Optional: lets the parent imperatively toggle `data-active` on the button.
  // react-grab freezes React state updates while active, so the Select button's
  // highlight can't be driven by useState — it's set on the DOM node directly.
  ref?: Ref<HTMLButtonElement>;
};

export const ToolbarButton = ({
  children,
  onClick,
  title,
  active,
  ref,
}: ToolbarButtonProps) => (
  <IgButton
    color="secondary"
    data-active={active === undefined ? undefined : String(active)}
    onClick={onClick}
    ref={ref}
    size="extraSmall"
    sx={DESIGN_TOKENS.button}
    title={title}
  >
    {children}
  </IgButton>
);
